/* Forsaken Flora custom face chain set builder */
(function () {
  'use strict';

  function money(cents) {
    if (window.FF && typeof window.FF.formatMoney === 'function') return window.FF.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function norm(v) {
    return String(v == null ? '' : v).trim().toLowerCase();
  }

  function initSet(root) {
    if (root.dataset.ffReady) return;
    root.dataset.ffReady = '1';

    var noChains = root.hasAttribute('data-no-chains');
    var cfgEl = root.querySelector('[data-set-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var form = root.querySelector('[data-ff-set-form]');
    var chainInputs = Array.prototype.slice.call(root.querySelectorAll('input[name="chain"]'));
    var charmInputs = Array.prototype.slice.call(root.querySelectorAll('input[name="charm"]'));
    var charmsStep = root.querySelector('[data-charms-step]');
    var charmsNote = root.querySelector('[data-charms-note]');
    var hint = root.querySelector('[data-chain-hint]');
    var preview = root.querySelector('[data-preview]');
    var previewEmpty = root.querySelector('[data-preview-empty]');
    var previewPhoto = root.querySelector('[data-preview-photo]');
    var previewNote = root.querySelector('[data-preview-note]');
    var previewChains = root.querySelector('[data-preview-chains]');
    var chainImgs = Array.prototype.slice.call(root.querySelectorAll('.ff-chain__img img[data-gold]'));
    var totalEl = root.querySelector('[data-total]');
    var baseEl = root.querySelector('[data-base-price]');
    var addBtn = root.querySelector('[data-add]');
    var saveBtn = root.querySelector('[data-save]');
    var msg = root.querySelector('[data-msg]');
    var sum = {
      style: root.querySelector('[data-sum-style]'),
      chains: root.querySelector('[data-sum-chains]'),
      hardware: root.querySelector('[data-sum-hardware]'),
      charms: root.querySelector('[data-sum-charms]')
    };

    var product = cfg.product;
    var styleIdx = -1;
    var strandsIdx = -1;
    if (product && product.options) {
      product.options.forEach(function (name, i) {
        if (norm(name) === norm(cfg.styleOption)) styleIdx = i;
        if (norm(name) === norm(cfg.strandsOption)) strandsIdx = i;
      });
    }

    function checkedValue(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el : null;
    }

    function findVariant(style, strands) {
      if (!product || !product.variants) return null;
      return product.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        var okStyle = styleIdx < 0 || norm(opts[styleIdx]) === norm(style);
        var okStrands = strandsIdx < 0 || norm(opts[strandsIdx]).replace(/[^0-9]/g, '') === String(strands);
        return okStyle && okStrands;
      }) || null;
    }

    function state() {
      var styleEl = checkedValue('style');
      var strands = parseInt((checkedValue('strands') || {}).value || '1', 10);
      var hardwareEl = checkedValue('hardware');
      var isAdjustable = !!(styleEl && styleEl.hasAttribute('data-adjustable'));
      var chains = chainInputs.filter(function (i) { return i.checked; });
      var charms = isAdjustable ? charmInputs.filter(function (i) { return i.checked; }) : [];
      var variant = findVariant(styleEl ? styleEl.value : '', strands);
      var base = variant ? variant.price : (parseInt(styleEl ? styleEl.dataset.base : '0', 10) + (strands - 1) * (cfg.extraStrand || 0));
      var basePrice1 = variant ? (findVariant(styleEl.value, 1) || variant).price : parseInt(styleEl ? styleEl.dataset.base : '0', 10);
      var charmTotal = charms.reduce(function (t, c) { return t + (parseInt(c.dataset.price || '0', 10) || 0); }, 0);
      return {
        style: styleEl ? styleEl.value : '',
        strands: strands,
        hardware: hardwareEl ? hardwareEl.value : '',
        isAdjustable: isAdjustable,
        chains: chains,
        charms: charms,
        variant: variant,
        base: basePrice1,
        total: base + charmTotal
      };
    }

    /* Swap every chain photo to the metal picked in step 3 */
    function applyMetal() {
      var hw = checkedValue('hardware');
      var metal = hw ? hw.getAttribute('data-metal') : '';
      if (metal !== 'gold' && metal !== 'silver') return metal;
      chainImgs.forEach(function (img) {
        var src = img.getAttribute('data-' + metal);
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      });
      return metal;
    }

    function render() {
      var metal = applyMetal();
      var s = state();
      document.dispatchEvent(new CustomEvent('ff-metal', { detail: { metal: metal } }));
      document.dispatchEvent(new CustomEvent('ff-strands', { detail: { strands: s.strands } }));

      // Limit chain picks to the strand count
      chainInputs.forEach(function (i) {
        i.disabled = !i.checked && s.chains.length >= s.strands;
        i.closest('.ff-chain').classList.toggle('is-disabled', i.disabled);
      });
      if (s.chains.length > s.strands) {
        s.chains.slice(s.strands).forEach(function (i) { i.checked = false; });
        s = state();
      }
      var left = s.strands - s.chains.length;
      hint.textContent = left > 0
        ? 'Pick ' + left + ' more chain' + (left === 1 ? '' : 's') + ' (' + s.strands + ' total).'
        : 'All ' + s.strands + ' chain' + (s.strands === 1 ? '' : 's') + ' chosen.';

      // Charms only for adjustable
      charmsStep.disabled = !s.isAdjustable;
      if (charmsNote) charmsNote.hidden = s.isAdjustable;
      if (!s.isAdjustable) charmInputs.forEach(function (i) { i.checked = false; });

      // Preview photo follows the strand count
      if (previewPhoto) {
        var want = s.strands >= 2 && cfg.preview2 ? cfg.preview2 : cfg.preview1;
        if (want && previewPhoto.getAttribute('src') !== want) previewPhoto.setAttribute('src', want);
      }
      if (previewNote) {
        var bits = [];
        if (metal === 'silver') bits.push('Photo shows gold hardware.');
        if (s.strands > 2) bits.push('Photo shows 2 strands; yours will have ' + s.strands + '.');
        previewNote.textContent = bits.join(' ');
        previewNote.hidden = bits.length === 0;
      }

      // Preview: clone chosen chain images
      previewChains.textContent = '';
      s.chains.forEach(function (input) {
        var img = input.closest('.ff-chain').querySelector('.ff-chain__img');
        var row = document.createElement('div');
        row.className = 'ff-set__preview-chain';
        row.appendChild(img.cloneNode(true));
        var cap = document.createElement('span');
        cap.textContent = input.value;
        row.appendChild(cap);
        previewChains.appendChild(row);
      });
      previewEmpty.hidden = noChains || s.chains.length > 0;

      sum.style.textContent = s.style;
      sum.chains.textContent = s.chains.length ? s.chains.map(function (i) { return i.value; }).join(', ') : 'None yet';
      sum.hardware.textContent = s.hardware;
      sum.charms.textContent = s.charms.length ? s.charms.map(function (i) { return i.value; }).join(', ') : 'None';

      baseEl.textContent = money(s.base);
      totalEl.textContent = money(s.total);

      if (product) {
        var ready = (noChains || s.chains.length === s.strands) && s.variant && s.variant.available;
        addBtn.disabled = !ready;
        if (s.variant && !s.variant.available) {
          msg.textContent = 'That combination is sold out right now.';
        } else if (msg.dataset.kind !== 'result') {
          msg.textContent = '';
        }
      }
    }

    function save() {
      var s = state();
      var data = {
        style: s.style,
        strands: s.strands,
        hardware: s.hardware,
        chains: s.chains.map(function (i) { return i.dataset.chainId; }),
        charms: s.charms.map(function (i) { return i.value; })
      };
      try {
        localStorage.setItem(cfg.storageKey, JSON.stringify(data));
        msg.dataset.kind = 'result';
        msg.textContent = 'Saved. Your set will be waiting when you come back on this device.';
      } catch (e) {
        msg.dataset.kind = 'result';
        msg.textContent = 'Could not save on this browser.';
      }
    }

    function restore() {
      var raw = null;
      try { raw = localStorage.getItem(cfg.storageKey); } catch (e) { raw = null; }
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      function pick(name, value) {
        var el = Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]')).find(function (i) { return i.value === String(value); });
        if (el) el.checked = true;
      }
      pick('style', data.style);
      pick('strands', data.strands);
      pick('hardware', data.hardware);
      chainInputs.forEach(function (i) { i.checked = (data.chains || []).indexOf(i.dataset.chainId) > -1; });
      charmInputs.forEach(function (i) { i.checked = (data.charms || []).indexOf(i.value) > -1; });
    }

    function addToCart(e) {
      e.preventDefault();
      var s = state();
      if (!s.variant) return;
      if (!noChains && s.chains.length !== s.strands) {
        msg.textContent = 'Please pick ' + s.strands + ' chain' + (s.strands === 1 ? '' : 's') + ' first.';
        return;
      }
      var setId = 'FF-' + Date.now().toString(36).toUpperCase();
      var props = {
        'Style': s.style,
        'Strands': String(s.strands),
        'Chains': s.chains.map(function (i) { return i.value; }).join(', '),
        'Hardware': s.hardware,
        '_set_id': setId
      };
      if (s.charms.length) props['Charms'] = s.charms.map(function (i) { return i.value; }).join(', ');

      var items = [{ id: s.variant.id, quantity: 1, properties: props }];
      s.charms.forEach(function (c) {
        if (c.dataset.variant) {
          items.push({ id: parseInt(c.dataset.variant, 10), quantity: 1, properties: { 'For set': s.style + ' set', '_set_id': setId } });
        }
      });

      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      msg.dataset.kind = 'result';
      msg.textContent = 'Adding your set...';

      fetch((window.FF && window.FF.routes ? window.FF.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          try { localStorage.removeItem(cfg.storageKey); } catch (err) { /* ignore */ }
          if (cfg.afterAdd === 'drawer' && window.FF && window.FF.openCartDrawer) {
            msg.textContent = 'Your set is in the cart.';
            window.FF.openCartDrawer();
          } else if (cfg.afterAdd === 'stay') {
            msg.textContent = 'Your set is in the cart.';
            if (window.FF && window.FF.refreshCartCount) window.FF.refreshCartCount();
          } else {
            window.location.href = (window.FF && window.FF.routes ? window.FF.routes.cart_url : '/cart');
          }
        })
        .catch(function (err) {
          msg.textContent = err.message;
        })
        .finally(function () {
          addBtn.removeAttribute('aria-busy');
          render();
        });
    }

    form.addEventListener('change', function () { msg.dataset.kind = ''; render(); });
    form.addEventListener('submit', addToCart);
    saveBtn.addEventListener('click', save);

    restore();
    render();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ff-set]')).forEach(initSet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
